/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Liveroomfunnelhis3Inputs */

const en_liveroomfunnelhis3 = /** @type {(inputs: Liveroomfunnelhis3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Said hi`)
};

const de_liveroomfunnelhis3 = /** @type {(inputs: Liveroomfunnelhis3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hi gesagt`)
};

/**
* | output |
* | --- |
* | "Said hi" |
*
* @param {Liveroomfunnelhis3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const liveroomfunnelhis3 = /** @type {((inputs?: Liveroomfunnelhis3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Liveroomfunnelhis3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_liveroomfunnelhis3(inputs)
	return de_liveroomfunnelhis3(inputs)
});
export { liveroomfunnelhis3 as "liveRoomFunnelHis" }